<template>

    <section id="search-results" class="section-product-filters section-p-extra relative" :class="isLoading ? 'opacity-30' : ''">
        <div class="container">

            <div class="section-product-filters__switch px-6 text-center lg:flex items-center justify-between">

                <h4 class="h4 text-offBlack mb-6 lg:mb-0"><span class="text-gold">{{ resultsNo }}</span> for you</h4>

                <div v-if="Object.keys(results).length" class="switch-wrap flex justify-center">
                    <div class="switch-button">
                        <input class="switch-button-checkbox" type="checkbox" @change="toggleImage" :checked="imageFloorPlans">
                        <label class="switch-button-label" for=""><span class="switch-button-label-span">Exterior</span></label>
                    </div>
                </div>


            </div>
            <category v-for="(category, key) in results" :key="key" :category="category"></category>
        </div>

        <div v-if="isLoading" class="top-1/2 z-50 absolute h-full w-full m-auto">
            <div class="text-center mb-6">
                <loadingcircle size=10></loadingcircle>
            </div>
        </div>
    </section>

</template>

<script>
import { computed, toRefs, onMounted } from 'vue'
import State, { toggleImage } from './State'
import Category from './Category'
import loadingcircle from "../loading-circle.vue";

export default  {
    components: {
        loadingcircle,
        Category
    },

    setup() {
        const resultsNo = computed(() => {
            let length = 0
            Object.keys(State.results).forEach(key => length += State.results[key].models.length)
            return length + (length > 1 || length === 0 ? ' results' : ' result')
        })

        onMounted(() => {
            const el = document.getElementById('search-results')
            el.scrollIntoView()
        })

        return { ...toRefs(State), resultsNo, toggleImage }
    }
}
</script>